{
  "app": {
    "name": "ما وراء الصمت",
    "tagline": "صحافة تكسر حاجز الصمت"
  },
  "nav": {
    "home": "الرئيسية",
    "articles": "المقالات",
    "about": "من نحن",
    "donate": "تبرع",
    "language": "اللغة",
    "menu": "القائمة",
    "close": "إغلاق",
    "search": "بحث"
  },
  "search": {
    "placeholder": "ابحث في المقالات…",
    "submit": "بحث",
    "clear": "مسح البحث",
    "inputLabel": "البحث في المقالات"
  },
  "actions": {
    "readMore": "اقرأ المزيد",
    "share": "مشاركة",
    "backToHome": "العودة للرئيسية",
    "loadMore": "تحميل المزيد"
  },
  "states": {
    "loading": "جارٍ التحميل…",
    "error": "حدث خطأ ما",
    "empty": "لا يوجد شيء لعرضه بعد",
    "notFound": "الصفحة غير موجودة",
    "unauthorized": "ليس لديك صلاحية الوصول لهذه الصفحة",
    "articleNotFound": "المقال الذي تبحث عنه غير موجود أو تم حذفه"
  },
  "footer": {
    "copyright": "© {{year}} Beyond Silence. All rights reserved.",
    "legalNotice": "الإشعارات القانونية",
    "privacy": "سياسة الخصوصية",
    "terms": "شروط الاستخدام",
    "contact": "اتصل بنا",
    "coffee": "ادعمنا بفنجان قهوة",
    "builtBy": "تم تطوير الموقع بواسطة"
  },
  "legal": {
    "legalNotice": {
      "title": "الإشعارات القانونية",
      "sections": [
        {
          "h": "ناشر الموقع",
          "b": "Beyond Silence، منصة صحفية ثلاثية اللغة (الفرنسية والإنجليزية والعربية)، يصدرها فريق Beyond Silence."
        },
        {
          "h": "التصميم والتطوير",
          "b": "Webnova — 60 Rue François Ier, 75008 باريس، فرنسا. رقم SIRET: 941 713 125 00016."
        },
        {
          "h": "الاستضافة",
          "b": "الموقع مستضاف لدى Cloudflare (Cloudflare Pages). لأي استفسار بخصوص الاستضافة، يُرجى التواصل مع الناشر."
        },
        {
          "h": "الملكية الفكرية",
          "b": "جميع محتويات هذا الموقع (نصوص، صور، رسومات، شعار، فيديوهات) ملكية حصرية لـ Beyond Silence ومساهميها. يُحظر أي إعادة إنتاج، ولو جزئية، دون موافقة كتابية مسبقة."
        },
        {
          "h": "المسؤولية",
          "b": "يسعى Beyond Silence إلى ضمان دقة المعلومات المنشورة على هذا الموقع، لكنه لا يضمن شموليتها. يُخلي الناشر مسؤوليته عن أي ضرر ناتج عن استخدام الموقع."
        },
        {
          "h": "الاتصال",
          "b": "لأي استفسار بخصوص هذه الإشعارات القانونية، يمكنك التواصل معنا عبر صفحة الاتصال على الموقع أو عبر البريد الإلكتروني contact@beyondsilence.fr."
        }
      ]
    },
    "privacy": {
      "title": "سياسة الخصوصية",
      "sections": [
        {
          "h": "1. المعلومات التي نجمعها",
          "b": "نجمع فقط المعلومات اللازمة لتشغيل Beyond Silence: بيانات تقنية مثل نوع المتصفح والصفحات التي تتم زيارتها، و—إذا قدّمت تبرعاً—بيانات الدفع التي يعالجها مزوّد الدفع لدينا. لا نطّلع أبداً على رقم بطاقتك الكامل ولا نخزّنه."
        },
        {
          "h": "2. كيف نستخدم معلوماتك",
          "b": "نستخدم هذه المعلومات لتشغيل الموقع وتحسينه، ومعالجة التبرعات، والامتثال للالتزامات القانونية. التحليلات مجمّعة ومجهولة الهوية؛ نستخدم معرّفات جلسات تحترم الخصوصية، ولا نستخدم أبداً عناوين IP الخام أو البريد الإلكتروني أو أي معرّفات شخصية ثابتة."
        },
        {
          "h": "3. ملفات تعريف الارتباط والتتبع",
          "b": "لا نستخدم ملفات تعريف ارتباط إعلانية أو تتبعاً إعلانياً. أي ملفات تعريف ارتباط نستخدمها ضرورية فقط لتشغيل الموقع وتفضيلات اللغة."
        },
        {
          "h": "4. مشاركة معلوماتك",
          "b": "لا نبيع معلوماتك الشخصية أبداً. تُشارك البيانات فقط مع مزوّدي خدمات موثوقين (الاستضافة وقاعدة البيانات والدفع) بالقدر اللازم لتقديم الخدمة، أو عندما يقتضي القانون ذلك."
        },
        {
          "h": "5. الاحتفاظ بالبيانات وحقوقك",
          "b": "نحتفظ بالبيانات الشخصية فقط للمدة اللازمة. يمكنك في أي وقت طلب الاطلاع على بياناتك أو تصحيحها أو حذفها بالتواصل معنا."
        }
      ]
    },
    "terms": {
      "title": "شروط الاستخدام",
      "sections": [
        {
          "h": "1. القبول",
          "b": "باستخدامك beyondsilence.fr، فأنت توافق على هذه الشروط. إذا لم توافق، يُرجى عدم استخدام الموقع."
        },
        {
          "h": "2. المحتوى والملكية الفكرية",
          "b": "جميع المقالات والصور والفيديوهات في هذا الموقع ملكٌ لـ Beyond Silence ومساهميها، ما لم يُذكر خلاف ذلك. يمكنك مشاركة الروابط واقتباسات قصيرة مع الإشارة إلى المصدر، لكن لا يجوز إعادة نشر محتوانا لأغراض تجارية دون إذن."
        },
        {
          "h": "3. التبرعات",
          "b": "التبرعات مساهمات طوعية تُعالج بشكل آمن عبر مزوّد الدفع لدينا. وهي ليست عملية شراء ولا تنشئ أي اشتراك أو حق وصول."
        },
        {
          "h": "4. الاستخدام المقبول",
          "b": "تتعهد بعدم إساءة استخدام الموقع، وعدم تعطيل تشغيله، وعدم محاولة الوصول إلى أنظمة أو بيانات مقيّدة."
        },
        {
          "h": "5. إخلاء المسؤولية والمسؤولية القانونية",
          "b": "يُقدَّم المحتوى الصحفي لأغراض المعلومات العامة. ورغم حرصنا على الدقة، لا نضمن الشمولية أو الحداثة ولا نتحمل أي مسؤولية عن الاعتماد على محتوانا."
        },
        {
          "h": "6. التعديلات والتواصل",
          "b": "قد نحدّث هذه الشروط من وقت لآخر. استمرارك في استخدام الموقع يعني قبولك لها. لديك أسئلة؟ تواصل معنا على contact@beyondsilence.fr."
        }
      ]
    }
  }
}
